<template>
  <pre data-module="page-settings">{{ $props }}</pre>
</template>

<script>
async function fontOptions(store) {
  const fonts = await store.dispatch('loadGoogleFonts');
  const key = this.name === 'pageHeadingFont' ? 'headingFont' : 'bodyFont';
  const typeFont = store.getters.settings[key];

  const options = fonts.map((font) => ({
    label: font,
    value: font,
  }));

  options.unshift({
    label: `Usar fonte global (${typeFont})`,
    value: 'global',
  });

  return options;
}

export default {
  name: 'PageSettings',
  props: {
    favicon: {
      type: String,
      default: undefined,
    },
    pageHeadingFont: {
      type: String,
      default: 'global',
    },
    pageBodyFont: {
      type: String,
      default: 'global',
    },
    primaryColor: {
      type: String,
      default: '#3E9AA6',
    },
    secondaryColor: {
      type: String,
      default: '#1c1b1b',
    },
    promotionColor: {
      type: String,
      default: '#ff7a00',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: undefined,
    },
    image: {
      type: String,
      default: undefined,
    },
    selectGtm: {
      type: String,
      default: 'global',
    },
    gtm: {
      type: String,
      default: undefined,
    },
    css: {
      type: String,
      default: '',
    },
    indexing: {
      type: Boolean,
      default: true,
    },
  },
  metadata: {
    tabs: [
      {
        name: 'content',
        label: 'Conteúdo',
        groups: [
          {
            name: 'config',
            label: 'Configurações básicas',
            fields: [
              {
                name: 'favicon',
                type: 'ImageFile',
                label: 'Favicon',
                maxWidth: 192,
                maxHeight: 192,
                helpText: 'Tamanho máx. de 192px por 192px.',
                enableRemoval: true,
              },
              {
                name: 'pageHeadScript',
                type: 'HTMLEditor',
                label: 'Cabeçalho da página <head>',
                helpText:
                  'Neste campo é possível inserir tags do tipo &#60;script&#62; no cabeçalho da sua página, como dados estruturados e scripts de terceiros.',
                spellcheck: false,
                maxlength: 50000,
                countChar: true,
              },
            ],
          },
          {
            name: 'gtm',
            label: 'GTM (Google Tag Manager)',
            helpText:
              'Espaço que permite inserir alterações via tags no site sem alterar o código. <a href="https://marketingplatform.google.com/about/tag-manager/" target="_blank">Saiba mais</a>.',
            fields: [
              {
                name: 'selectGtm',
                type: 'VueSelect',
                label: 'Seletor de GTM',
                helpText:
                  'Você pode configurar uma chave global para o GTM no seguinte link: <a href="/settings#site" target="_blank">Configuração do site</a>',
                // TODO: Get props default to work in page settings
                default: 'global',
                options({ globalGtm }) {
                  return [
                    {
                      label: 'Sem GTM',
                      value: 'none',
                    },
                    {
                      label: `Global (${globalGtm || 'não configurado'})`,
                      value: 'global',
                    },
                    {
                      label: 'Customizado',
                      value: 'custom',
                    },
                  ];
                },
              },
              {
                name: 'gtm',
                type: 'ShortText',
                label: 'Código do contêiner GTM',
                isEnabled({ selectGtm }) {
                  return selectGtm === 'custom';
                },
                maxlength: 12,
                mask: {
                  // imaskjs options
                  mask: /^[A-Z0-9-]+$/,
                  prepare(str) {
                    return str.toUpperCase();
                  },
                },
                validation: {
                  format: {
                    pattern: /^(GTM-[A-Z0-9]{4,8})?$/,
                    message: 'ID do GTM inválido.',
                  },
                },
              },
            ],
          },
        ],
      },
      {
        name: 'appearance',
        label: 'Aparência',
        groups: [
          {
            name: 'colors',
            label: 'Cores',
            fields: [
              {
                name: 'primaryColor',
                type: 'ColorPicker',
                label: 'Cor primária',
              },
              {
                name: 'secondaryColor',
                type: 'ColorPicker',
                label: 'Cor secundária',
              },
              {
                name: 'promotionColor',
                type: 'ColorPicker',
                label: 'Cor Promoção',
              },
            ],
          },
          {
            name: 'fonts',
            label: 'Fontes',
            fields: [
              {
                name: 'pageHeadingFont',
                type: 'VueSelect',
                label: 'Fonte dos cabeçalhos',
                options: {
                  source: 'store',
                  handler: fontOptions,
                },
              },
              {
                name: 'pageBodyFont',
                type: 'VueSelect',
                label: 'Fonte do corpo',
                options: {
                  source: 'store',
                  handler: fontOptions,
                },
              },
            ],
          },
          {
            name: 'css',
            label: 'CSS personalizado',
            fields: [
              {
                name: 'css',
                type: 'HTMLEditor',
                language: 'css',
                label: 'Digite ou cole o código CSS',
                helpText: `
                  <ul>
                    <li><strong>-</strong> Importante validar o CSS no preview devido a possíveis diferenças causadas pela prioridade dos seletores.</li>
                    <li><strong>-</strong> É possível aplicar CSS a um módulo específico usando o seu ID, por exemplo: <strong>#PromoList-465891217240</strong>.</li>
                    <li><strong>-</strong> Usar o atributo data-module para selecionar todos os módulos do mesmo tipo, por exemplo: <strong>[data-module="promo-list"]</strong>.</li>
                    <li><strong>-</strong> Evite usar atributos como <strong>data-v-123412</strong> como seletor, pois esses valores mudam ao longo do tempo.</li>
                    <br>
                    <li><strong>Observação:</strong> media queries não refletem no canvas, apenas no preview e na página publicada.</li>
                </ul>
                `,
                spellcheck: false,
                maxlength: 50000,
                countChar: true,
              },
            ],
          },
        ],
      },
    ],
  },
};
</script>
